module.exports = __webpack_public_path__ + "media/src/application/media/ublock-c7e06ce6ca26665dc222570bbffeef53.jpg";